import React from "react";
import ImageLoader from "../images/ImageLoader";
import { Row, Col } from "react-bootstrap";
import { CATALOGUETYPES } from "../../constants";

var Card = function Card(props) {
  var item = props.item,
      _props$full = props.full,
      full = _props$full === void 0 ? false : _props$full,
      _props$topAction = props.topAction,
      topAction = _props$topAction === void 0 ? function () {
    console.log("action");
  } : _props$topAction,
      _props$returnAction = props.returnAction,
      returnAction = _props$returnAction === void 0 ? function () {
    console.log("returnAction");
  } : _props$returnAction;
  var _item$Product = item.Product,
      Product = _item$Product === void 0 ? {} : _item$Product,
      ReturnDetails = item.ReturnDetails;
  var DisplayName = Product.DisplayName,
      ImageFilePath = Product.ImageFilePath,
      CatalogName = Product.CatalogName;
  var IsReturnInitiated = ReturnDetails.IsReturnInitiated,
      Reason = ReturnDetails.Reason,
      returnQty = ReturnDetails.Quantity,
      ReturnWindowExpired = ReturnDetails.ReturnWindowExpired,
      Status = ReturnDetails.Status;
  var image = {
    value: {
      src: ImageFilePath || "",
      alt: DisplayName,
      title: DisplayName
    }
  };
  var isRetail = CatalogName === CATALOGUETYPES.retail;
  return /*#__PURE__*/React.createElement(Row, {
    className: "\n      cb-account-order__item\n      ".concat(full ? "cb-account-order__item--detail" : "", "\n      ")
  }, /*#__PURE__*/React.createElement(Col, {
    className: full ? "d-flex" : ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order__item-image"
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    isEditing: false,
    media: image,
    className: "cb-card__image cb-card__image--contain"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-order__item-description"
  }, /*#__PURE__*/React.createElement("p", null, item.Product.DisplayName), /*#__PURE__*/React.createElement("p", null, "$", item.LineCost))));
};

export default Card;